import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-white text-slate-600 border-t border-slate-200 pt-16 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Col 1: Brand & Intro */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center group">
              <div className="flex flex-col">
                <span className="text-xl font-black text-slate-900 tracking-tight group-hover:text-sky-600 transition-colors">
                  Insightly Care
                </span>
                <span className="text-[10px] uppercase font-bold tracking-widest text-slate-500">
                  IT & Tech Recruitment
                </span>
              </div>
            </Link>
          </div>

          {/* Col 2: Navigation */}
          <div className="space-y-4">
            <h3 className="text-xs font-bold uppercase tracking-wider text-slate-900">
              Navigation
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="hover:text-slate-900 transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/om-birgitte" className="hover:text-slate-900 transition-colors">
                  Om Birgitte Vilsgaard
                </Link>
              </li>
              <li>
                <Link to="/erfaring" className="hover:text-slate-900 transition-colors">
                  Erfaring
                </Link>
              </li>
              <li>
                <Link to="/referencer" className="hover:text-slate-900 transition-colors">
                  Referencer & Anbefalinger
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-slate-900 transition-colors">
                  Galleri
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-slate-900 transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Services */}
          <div className="space-y-4">
            <h3 className="text-xs font-bold uppercase tracking-wider text-slate-900">
              Rekrutteringsydelser
            </h3>
            <ul className="space-y-2.5 text-sm text-slate-600">
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-check text-slate-400 text-xs" aria-hidden="true" />
                <span>Executive & Direct Search</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-check text-slate-400 text-xs" aria-hidden="true" />
                <span>Software Developer Recruitment</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-check text-slate-400 text-xs" aria-hidden="true" />
                <span>IT-Arkitekter & Lead Engineers</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-check text-slate-400 text-xs" aria-hidden="true" />
                <span>Kompetence- & Personlighedstest</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-solid fa-check text-slate-400 text-xs" aria-hidden="true" />
                <span>C-level & Leadership Sparring</span>
              </li>
            </ul>
          </div>

          {/* Col 4: Contact & Firm Details */}
          <div className="space-y-4">
            <h3 className="text-xs font-bold uppercase tracking-wider text-slate-900">
              Kontaktoplysninger
            </h3>
            <div className="space-y-3 text-sm">
              <p className="font-semibold text-slate-900">Insightly Care</p>
              <p className="flex items-start gap-2 text-slate-600">
                <i className="fa-solid fa-location-dot text-slate-400 mt-1" aria-hidden="true" />
                <span>Dronningemaen 68, 5700 Svendborg</span>
              </p>
              <p className="flex items-center gap-2 text-slate-600">
                <i className="fa-solid fa-phone text-slate-400" aria-hidden="true" />
                <a
                  href="tel:28839488"
                  className="hover:text-sky-600 transition-colors whitespace-nowrap"
                >
                  28 83 94 88
                </a>
              </p>
              <p className="flex items-center gap-2 text-slate-600">
                <i className="fa-solid fa-envelope text-slate-400" aria-hidden="true" />
                <a
                  href="mailto:bgv@insightly.dk"
                  className="hover:text-sky-600 transition-colors whitespace-nowrap"
                >
                  bgv@insightly.dk
                </a>
              </p>
              <div className="pt-2">
                <a
                  href="https://www.linkedin.com/in/birgitte-vilsgaard-9b2986b2/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-3 py-1.5 bg-slate-100 hover:bg-sky-600 hover:text-white text-slate-700 text-xs font-medium transition-colors border border-slate-200"
                >
                  <i className="fa-brands fa-linkedin text-sm" aria-hidden="true" />
                  <span>Birgitte Vilsgaard på LinkedIn</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-500 gap-4">
          <p>© {new Date().getFullYear()} Insightly Care / Insightly ApS. CVR: 43779362. Alle rettigheder forbeholdes.</p>
          <p className="flex items-center gap-2">
            <span>Bygget til IT & Tech recruitment af højeste standard</span>
          </p>
        </div>
      </div>
    </footer>
  )
}
